import React from 'react';
import AllRoute from '../router'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const App = () => {

  return (
    <div className="App" id='scrool' style={{overflowX:'hidden'}}>
      {/* WhatsappLink now lives inside AllRoute's <BrowserRouter> so it can read
          the current route and hide itself on the new homepage. */}
      <AllRoute />
      <ToastContainer />
      <div className="cursor-ball"></div>
      <div className="cursor-ball inner-ball"></div>
    </div>
  );
}

export default App;